import { getJobList } from './GetJobList';

/**
 * Jobs API Client
 * Provides low-level HTTP calls to jobs endpoints
 */
export const JobsApi = {
  getJobList,
};
